import React from 'react'

import { checkBreakpoints } from 'utils/client/clientInfo'

export const ResizeContext = React.createContext(checkBreakpoints(true))
export const ResizeProvider = ResizeContext.Provider
export const ResizeConsumer = ResizeContext.Consumer
